import React from 'react';
import { connect } from 'react-redux';

function OneFooter(props) {

  var phoneResult = props.user_phone.substr(0, 3) + " " + props.user_phone.substr(3, 3) + " " + props.user_phone.substr(6, 3);
    return (
    <>
      <div id="divtocopy" style={{padding: "0"}}>
              <table cellPadding="0" width="740" style={{verticalAlign: "-webkit-baseline-middle"}}>
              <tbody>
              <tr className="gmail-fix">
                <td>
                  <table cellPadding="0" cellSpacing="0" border="0" align="center" width="500">
                    <tbody>
                    <tr>
                      <td cellPadding="0" cellSpacing="0" border="0" height="1">
                        <img src="https://columbusenergy.pl/lp/stopka/spacer.jpg" width="500" height="1" style={{display:"block",maxHeight:"1px",minHeight:"1px",inWidth:"500px",width:"500px"}} alt=""/>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <table width="100%">
                    <tbody>
                    <tr>
                      <td style={{width:"155px", textAlign:"left", padding:"10px"}}>
                        <table cellPadding="0" width="155">
                          <tbody>
                            <tr>
                              <td width="155">
                                <img style={{verticalAlign:"middle",borderRadius:'6px'}} src={props.user_image} alt="avatar" width="155"/>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td style={{color:"rgb(0, 0, 0)", verticalAlign:"top",padding:"12px 0 0"}}>
                      <table style={{width:"100%"}}>
                        <tbody>
                          <tr>
                            <td style={{paddingBottom:"8px"}}>
                              <h1 style={{fontFamily:"Arial",margin:"0", fontWeight:"400",fontSize:"25px",color:"#331590",lineHeight:"25px"}}>
                                {props.user_name}
                                <span style={{fontSize:"25px",fontFamily:"Arial",fontWeight:"700"}}>
                                  &nbsp;{props.user_surname}
                                </span>
                              </h1>
                              <h4 style={{fontFamily:"Arial",fontWeight:"normal",margin:"0",fontSize:"20px",color:"#fd5600"}}>
                                {props.user_position}
                              </h4>
                            </td>
                          </tr>
                          <tr>
                            <td width="350" style={{paddingBottom:"8px",lineHeight:"20px"}}>
                              <table>
                                <tbody>
                                <tr>
                                  <td>
                                      {!props.user_phone ? (
                                      <span></span>
                                    ) : (
                                      <>
                                      <img style={{verticalAlign:"bottom",width:"15px", marginBottom:"3px"}} src="https://columbusenergy.pl/lp/stopka/generator/assets/one-phone-icon.png" alt=""/>
                                      &nbsp;&nbsp;<span style={{fontFamily:"Arial",lineHeight:"16px",fontWeight:"600",fontSize:"18px",display:"inline-block"}}>
                                        +48 {phoneResult}
                                      </span>
                                      </>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <img style={{verticalAlign:"middle", width:"16px"}} src="https://columbusenergy.pl/lp/stopka/generator/assets/one-mail-icon.png" alt=""/>
                                    &nbsp;&nbsp;<span style={{fontFamily:"Arial",margin:"0",lineHeight:"16px",fontWeight:"400",fontSize:"18px",display:"inline-block"}}>
                                        {props.user_email}
                                    </span>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <table width='150' style={{borderSpacing:"0",marginTop:"5px"}}>
                                <tbody>
                                    <tr>
                                      <td width='12' align="left" style={{textAlign:"left"}}>
                                      <a style={{display:"inline-block", textDecoration: "none"}} href="https://www.facebook.com/columbuselite" target="_blank">
                                            <img width='22' src="https://columbusenergy.pl/lp/stopka/generator/assets/one-fb-logo.png" alt=""/>
                                          </a>
                                      </td>
                                      <td width='12' align="left" style={{textAlign:"left"}}>
                                      <a style={{textDecoration: "none"}} href="https://www.instagram.com/columbus.elite/" target="_blank">
                                            <img width='22' src="https://columbusenergy.pl/lp/stopka/generator/assets/one-instagram-logo.png" alt=""/>
                                          </a>
                                      </td>
                                      <td width='12' align="left"style={{textAlign:"left"}}>
                                          <a style={{display:"inline-block",textDecoration:"none"}} href="https://www.linkedin.com/company/columbus-one/" target="_blank">
                                            <img width='22' src="https://columbusenergy.pl/lp/stopka/generator/assets/one-linkedin-logo.png" alt=""/>
                                          </a>
                                      </td>
                                      <td width='12' align="left" style={{textAlign:"left"}}>
                                          <a style={{display:"inline-block",textDecoration:"none"}} href="https://www.youtube.com/channel/UClJgiUV46c4zUke-hz8xjow" target="_blank">
                                            <img width='22' src="https://columbusenergy.pl/lp/stopka/generator/assets/one-yt-logo.png" alt=""/>
                                          </a>
                                      </td>
                                      <td width='12' align="left" style={{textAlign:"left"}}>
                                      <a style={{textDecoration: "none"}} href="https://columbusone.pl/" target="_blank"> 
                                            <img width='22' src="https://columbusenergy.pl/lp/stopka/generator/assets/one-web-logo.png" alt=""/>
                                          </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                          </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <table style={{backgroundImage:"url('https://columbusenergy.pl/lp/stopka/generator/assets/columbus-one-stopka.jpg')", backgroundSize: "cover", width: "100%"}}>
                    <tbody>
                    <tr>
                      <td style={{width:"260px",padding: "12px"}}>
                        <table style={{borderSpacing: "0"}}>
                          <tbody>
                          <tr>
                            <td>
                              <img src="https://columbusenergy.pl/lp/stopka/generator/assets/one-columbus-logo.png" alt="" style={{verticalAlign:"middle",width:"70px"}}/>
                            </td>
                            <td style={{lineHeight:"16px",fontSize:"14px",fontFamily:"Arial",color:"rgb(255, 255, 255)",fontWeight:"400",padding:"0 0 0 20px"}}>
                              <span style={{color:"#B691F5",fontSize:"14px",fontWeight:"700",verticalAlign: "middle",lineHeight:"16px"}}>
                                Columbus One S.A.
                              </span>
                              <br />ul. Pana Tadeusza 4
                              <br />30-727 Kraków
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </td>
                      <td>
                        <table style={{borderSpacing:"0",width:"100%"}}>
                            <tr>
                              <td style={{textAlign:"center",width:"212px",paddingTop:"10px"}}>
                              <img src="https://columbusenergy.pl/lp/stopka/generator/assets/one-team-one-goal.png" alt="" style={{verticalAlign:"middle",width:"212px"}}/>
                              </td>
                            </tr>
                        </table>
                      </td>
                      <td>
                        <table style={{borderSpacing:"0",width:"100%"}}>
                            <tr>
                              <td style={{textAlign:"right",width:"120px",paddingRight:"20px"}}>
                                <a href="https://group.columbusenergy.com/" target="_blank">
                                  <img src="https://columbusenergy.pl/lp/stopka/generator/assets/one-columbus-white.png" alt="" style={{verticalAlign:"middle",width:"120px"}}/>
                                </a>
                              </td>
                            </tr>
                        </table>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              </tbody>
            </table>
      </div>
    </>
    );
}

function mapStateToProps(state) {
  return {
    user_name: state.user_reducer.user_name,
    user_surname: state.user_reducer.user_surname,
    user_position: state.user_reducer.user_position,
    user_email: state.user_reducer.user_email,
    user_phone: state.user_reducer.user_phone,
    user_image: state.user_reducer.user_image,
  }
}
export default connect(mapStateToProps)(OneFooter);